import { CommonModule, Location } from '@angular/common';
import { Component, OnInit, signal, Renderer2, Inject, inject } from '@angular/core';
import { Router, RouterModule } from '@angular/router';

@Component({
  selector: 'app-header',
  imports: [RouterModule, CommonModule],
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit {
  currentRoute$ = signal<string>('');
  _location = inject(Location);
  constructor(
    private $router: Router,
    private renderer: Renderer2,
  ) {}

  ngOnInit(): void {
    if (typeof document !== 'undefined') {
      setTimeout(() => {
        const mobileMenu = document.getElementById('mobileMenu');
        if (mobileMenu) {
          mobileMenu.addEventListener('show.bs.collapse', () => {
            this.renderer.addClass(document.body, 'menu-open');
          });
          mobileMenu.addEventListener('hide.bs.collapse', () => {
            this.renderer.removeClass(document.body, 'menu-open');
          });
          mobileMenu.addEventListener('shown.bs.collapse', () => {
            this.renderer.addClass(document.body, 'menu-open');
          });

          const menuLinks = mobileMenu.querySelectorAll('a[href^="#"]');
          menuLinks.forEach((link) => {
            link.addEventListener('click', (e) => {
              const href = (e.currentTarget as HTMLAnchorElement).getAttribute('href');
              if (href && href !== '#') {
                e.preventDefault();
                const bsCollapse =
                  (window as any).bootstrap.Collapse.getInstance(mobileMenu) ||
                  new (window as any).bootstrap.Collapse(mobileMenu, { toggle: false });
                bsCollapse.hide();
                setTimeout(() => {
                  const targetId = href.substring(1);
                  const targetElement = document.getElementById(targetId);
                  if (targetElement) {
                    const navbar = document.querySelector('.navbar');
                    const navbarHeight = navbar ? navbar.clientHeight : 80;
                    const elementPosition =
                      targetElement.getBoundingClientRect().top + window.pageYOffset;
                    const offsetPosition = elementPosition - navbarHeight;
                    window.scrollTo({
                      top: offsetPosition,
                      behavior: 'smooth',
                    });
                  }
                }, 300);
              }
            });
          });
        }
      }, 100);
    }
  }

  get isHomePage(): boolean {
    const url = this.$router.url.split('#')[0];
    const publicRoutes = [
      '/',
      '/politicas-privacidad',
      '/terminos-condiciones',
      '/certificaciones',
    ];
    return publicRoutes.includes(url);
  }

  get isAuthPage(): boolean {
    const url = this.$router.url.split('#')[0];
    return url.startsWith('/acceder');
  }

  handleGoBack() {
    this._location.back();
  }
}
